export default "__VITE_ASSET__CdZJV57C__"